<mat-card>
    <div class="row">
        <prl-label value="label.dashboard.monthly.commission"></prl-label>
        <mx-info-tooltip [config]="commissionConfig"></mx-info-tooltip>
    </div>
    <div class="currency">
        <prl-label value="label.dashboard.commission.currency"></prl-label>
        <label>{{ this.monthlyCommission }}</label>
    </div>
    <hr/>
    <div class="row">
        <prl-label value="label.dashboard.calculated.date"></prl-label>
        <mx-info-tooltip [config]="dateConfig"></mx-info-tooltip>
    </div>
    <label>{{getCalculatedDate() | zoneDate:'yyyy-MM-dd HH:mm z'}}</label>
</mat-card>
